import React from 'react';
import { useTranslations } from '@lang';
import { Price } from '@common/components/Price';

import { Extras } from 'shared-types/Common';
import { SelectionList, SelectionListItem, SelectionPrice } from './GuestSelection.styles';

type GuestSelectionProps = {
  rows: Extras[];
  isExtra?: boolean;
};

export const GuestSelection: React.FC<GuestSelectionProps> = ({ rows, isExtra = false }) => {
  const { t } = useTranslations();

  return (
    <SelectionList>
      {rows.map(({ name, price }) => (
        <SelectionListItem key={name}>
          <span>
            {isExtra ? '+ ' : ''}
            {name}
          </span>
          {isExtra ? (
            <SelectionPrice>
              {price && price?.amount > 0 ? <Price price={price} /> : t('common.foc')}
            </SelectionPrice>
          ) : (
            <SelectionPrice>{t('common.included')}</SelectionPrice>
          )}
        </SelectionListItem>
      ))}
    </SelectionList>
  );
};
